import React from "react";
import TextCitation from "./citationTypes/TextCitation";
import ChowsAndBlogsCitations from "./citationTypes/ChowsAndBlogsCitations";
import PodcastCitations from "./citationTypes/PodcastCitations";
import ExclusiveContentCitations from "./citationTypes/ExclusiveContentCitations";
import BookCitations from "./citationTypes/BookCitations";

interface CitationRendererProps {
  citation: string | any; // can be string or object
  isLoading?: boolean;
  onCitationClick?: (citation: any) => void;
}

const CitationHandler: React.FC<CitationRendererProps> = ({
  citation,
  isLoading,
  onCitationClick,
}) => {
  if (typeof citation === "string") {
    return (
      <TextCitation
        isLoading={isLoading}
        citation={citation }
        onCitationClick={onCitationClick}
      />
    );
  }

  const { media_type, link} = citation;

  if (media_type === "podcast" || media_type === "sps_podcast") {
    return (
      <PodcastCitations
        citation={citation}
        isLoading={isLoading}
        onCitationClick={onCitationClick}
      />
    );
  }

  if (media_type === "blog" && link !== "" ) {
    return (
      <ChowsAndBlogsCitations citation={citation} />
    );
  }
  if (media_type === "books") {
    return <BookCitations citation={citation} onCitationClick={onCitationClick} />;
  }
  return (
    <ExclusiveContentCitations
      citation={citation}
      isLoading={isLoading}
      onCitationClick={onCitationClick}
    />
  );
};

export default CitationHandler;
